// dependencies
import React from "react";

// styles
import styles from "./css/SecondaryBtn.module.css";

export default function SecondaryBtn({ text, fontSize, onClick}) {

    return (
        // background
        <button className={styles.btn} onClick={onClick}>
            {text}
        </button>
    );
}
